import { MaterialExtractSpecType } from "pages/material-extracted-log/model";

const activeInlogCellRenderer = ({
  data
}: {
  data: MaterialExtractSpecType;
}) => {
  return data.feature_materials_aggregate?.aggregate?.count ||
    data.grouped_parent_id ? (
    <div className="flex justify-center items-center h-full">
      <span className="px-1 py-1 text-xs rounded border-gray-300 border border-solid bg-gray-100 shadow-sm">
        In Log
      </span>
    </div>
  ) : null;
};

export default activeInlogCellRenderer;
